import { ProductItem } from './product-item-model';
import { GenericItem } from './generic-item-model';
import { PlaceItem } from './place-item-model';
import { MediaItem } from './media-item-model';

import * as fb from '@/firebase';

export enum ItemType {
  Generic = 'Generic',
  Product = 'Product',
  Media = 'Media',
  Place = 'Place',
  IOSApp = 'IOSApp'
}

export abstract class AbstractItemModel {
  public title: string;
  public subtitle: string;
  public description: string;
  public tags: string[];
  public type: string;
  public url: string;
  public imageURL?: string;
  public id: string;
  public timeAdded: Date;
  public listId: string;
  public listTitle: string;
  public authorId: string;

  public fromFirebaseDoc(id: string, document: any): AbstractItemModel {
    return null;
  }
  public toFirebaseDoc(): any {
    return null;
  }

  public get isProduct() {
    return this.type === ItemType.Product.toString();
  }
  public get asProduct(): ProductItem {
    // @ts-ignore
    return this as ProductItem;
  }

  public get isPlace() {
    return this.type === ItemType.Place.toString();
  }
  public get asPlace(): PlaceItem {
    // @ts-ignore
    return this as PlaceItem;
  }

  public get isGeneric() {
    return this.type === ItemType.Generic.toString();
  }
  public get asGeneric(): GenericItem {
    // @ts-ignore
    return this as GenericItem;
  }

  public get isMedia() {
    return this.type === ItemType.Media.toString();
  }
  public get asMedia(): MediaItem {
    // @ts-ignore
    return this as MediaItem;
  }

  public get firebaseConsoleLink() {
    return `https://console.firebase.google.com/project/${fb.firebaseConfig.projectId}/database/firestore/data~2F${fb.itemsCollection.id}~2F${this.id}`;
  }

  get link() {
    return '/list/id/' + this.listId + '#item=' + this.id;
  }

  get listLink() {
    if (this.listId) {
      return '/list/id/' + this.listId;
    } else {
      return null;
    }
  }
}
